import "./HeroImgStyles.css";

import React from 'react'

import IntroImg from "../assets/flowers.JPG"
import { Link } from "react-router-dom"

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="intro-img" src={IntroImg} alt="IntroImg" />
      </div>
      <div className="content">
        <p>Electrical & Computer Engineer</p>
        <h1>Learn more.</h1>
        <div>
          <Link to="/project" className="btn">Projects</Link>
          <Link to="https://www.oralhealthgroup.com/?s=charlotte+fritz" className="btn btn-light">Publications</Link>

        </div>
      </div>
    </div >
  )
}

export default HeroImg